import { ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { MsgConfig } from 'src/app/app.messages';
import { FiltersEnum, IdentifierTypeEnum } from 'src/app/models/messaging.enum';
import { CommonService, PatPreDrugModalService } from 'src/app/services';
import { UserService } from 'src/app/services/user.service';
import { WebPubSubService } from 'src/app/services/WebPubSubService';
import { AlertService } from "src/app/services";
import { PatientComponent } from '../../patient';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
    selector: 'app-spc-cloud',
    styleUrls: ['./spc-cloud.component.css'],
    templateUrl: './spc-cloud.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class spcCloudComponent implements OnInit{
    @ViewChild('menuIcon', { static: true }) menuIcon!: ElementRef;   
    @ViewChild('popupMenu', { static: true }) popupMenu!: ElementRef;
    messages: any[] = [];
    enterMessage: any[] = [];
    userName: any;
    patientID: any;
    gender:any;
    activeInactive:boolean = false;
    @Input() userData: any;
    selectedPeriod: string = FiltersEnum.ALLHISTORY;
    searchText: string = '';
    searchHistoryText: string = '';
    enteredMessage: string = '';
    placeholderMessage: string = MsgConfig.EnterMsg;
    npi:any;
    pharmacistName:any;
    resetMessages: boolean = false;
    isError: boolean = false;
    unsubscribe$: Subject<void> = new Subject();
    userSelected: boolean = false;
    patientInfo: any;
    patDOB: string;
    age: number;
    phoneNumber: any;
    constructor(private cd: ChangeDetectorRef,
        private _webPubSubService: WebPubSubService,
        private _userServ: UserService,
        private ngZone: NgZone,
        private _commonServ:CommonService,
        private _alertService: AlertService,
        private _modalServ: NgbModal,
         private _patPreDrugService: PatPreDrugModalService
    ) { }

    ngOnInit() {
        this.placeholderMessage = MsgConfig.EnterMsg;
        this.pharmacistName = this._commonServ.DecryptData(localStorage.getItem("PharmacistName"));
        this.npi = this._userServ.getToken("UniquePharmacyId");
        if(this.userData && this.userData?.identifier){
            this.onUserSelected(this.userData);
        } else{
            this.userSelected = false;
        }
    }

    onUserSelected(userData: any) {
        this.patientID = userData?.identifier;
        this.userName = userData?.userName;
        this.gender = userData?.gender;
        this.resetMessages = true;
        this.activeInactive = (userData?.identifier && userData) ? true : false;
        this.userSelected = false;
    }
    onEnter(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.sendMessage();
        }
    }
    routeToEditPatient(){
        const modalRef = this._modalServ.open(PatientComponent, {
            backdrop: false,
            size: "lg",
            windowClass: "md-xx-lg comp--modal modal-center-to-page modal-patient",
            keyboard: false
        });
        modalRef.componentInstance.patientID = this.patientID;
        modalRef.componentInstance.ClosePatientModal
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(resp => {
            if(resp){
                this.getInfo();
            }
            modalRef.close();
        });
    }

    routeToPatientHistory(){
        this._patPreDrugService._patPreDrugModal$.next("patHist");
        const modalRef = this._patPreDrugService.modalInstanceRef;
        modalRef.componentInstance.patientID = this.patientID;
        modalRef.componentInstance.popUpOpenFr = "rph";
        modalRef.componentInstance.IsPopUpClosed
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(resp => {
            if(resp){
                this.getInfo();
            }
            modalRef.close();
            this._patPreDrugService._patPreDrugModal$.next(null);
        });
    }
    closeInfo(){
        this.userSelected = false;
    }
    openInfo(){
        this.userSelected = this.patientID ? true : false;
        if(this.patientID){
            this.getInfo();
        }
    }
    getInfo() {
        this._commonServ.getEditPatientInformation(this.patientID).pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
            if(resp){
                this.patientInfo = resp;
                this.patDOB =  moment(this.patientInfo?.Person?.BirthDt).format(MsgConfig.DATE_FORMAT);
                this.age = this.calculateAge(this.patDOB);
                this.phoneNumber = this.patientInfo?.Phones?.find(x => x?.PhoneCatId === 2)?.xPhone;
            }
        });
    }
    calculateAge(birthDate: string): number {
        return moment().diff(moment(birthDate, MsgConfig.DATE_FORMAT), 'years');
    }
    sendMessage(){
        if (!navigator.onLine) {
            this._alertService.error(MsgConfig.NO_Internet);
            this.enteredMessage = "";
            return;
        }
        if (!this.enteredMessage.trim()) { 
            this.isError = true;
            this.placeholderMessage = MsgConfig.PleaseEnterMsg;
            return;
        }
        this.resetMessages = false;
        this.isError = false;
        this.placeholderMessage = MsgConfig.EnterMsg;
        if (this.enteredMessage.trim() && this.patientID) {
            const enterMessage = {
                date: moment().toISOString(),
                message: this.enteredMessage,
                sender: {
                    identifier: this.npi,
                    identifierType: IdentifierTypeEnum.NPI,
                    userName: this.pharmacistName
                },
                lastMessageReceivedAt: new Date().toISOString(),
                IsRead: false
            };
            this._webPubSubService.sendMessageToPatient(this.npi, this.patientID, this.enteredMessage, this.pharmacistName, this.userName)
            .then(() => {
                this.enterMessage = [...this.enterMessage, enterMessage];
                this.cd.detectChanges();
                this.enteredMessage = '';
                this.ngZone.runOutsideAngular(() => {
                    requestAnimationFrame(() => {
                        this.scrollToBottom();
                    });
                });
            })
            .catch((error) => {
                console.error('Error sending message:', error);
            });
        } else {
            console.error('Message or PatientID is missing!');
        }
    }
    onFocus(): void { 
        if (this.isError) {
            this.isError = false;
            this.placeholderMessage = MsgConfig.EnterMsg;
        }
    }
    dateList = [
        { Name: FiltersEnum.ALLHISTORY, Id: FiltersEnum.ALLHISTORY },
        { Name: FiltersEnum.TODAY, Id: FiltersEnum.TODAY },
        { Name: FiltersEnum.LASTONEWEEK, Id: FiltersEnum.LASTONEWEEK },
        { Name: FiltersEnum.LASTONEMONTH, Id: FiltersEnum.LASTONEMONTH },
        { Name: FiltersEnum.LASTSIXMONTHS, Id: FiltersEnum.LASTSIXMONTHS },
        { Name: FiltersEnum.LASTONEYEAR, Id: FiltersEnum.LASTONEYEAR }
    ];
    togglePopup() { 
        const popupMenu = this.popupMenu.nativeElement;
        const computedStyles = window.getComputedStyle(popupMenu);
        const display = computedStyles.getPropertyValue('display'); 

        if (display === 'none') {
            const icon = this.menuIcon?.nativeElement;
            const position = icon.getBoundingClientRect();
            const top = position.bottom + window.scrollY - 10;
            let left = position.left - 90;
    
            const screenWidth = window.innerWidth;
            if (screenWidth <= 720) {
            left -= 14;
            }
            popupMenu.style.display = 'block';
            popupMenu.style.top = `${top}px`;
            popupMenu.style.left = `${left}px`;
        } else { 
            popupMenu.style.display = 'none';
        }
    }

    ngAfterViewInit() {
        document.addEventListener('click', (event) => this.onClick(event));
    }
    
    onClick(event: MouseEvent) {
        if (this.popupMenu?.nativeElement && this.menuIcon?.nativeElement) {
            const popupMenu = this.popupMenu.nativeElement;
            const menuIcon = this.menuIcon.nativeElement; 
            if (!menuIcon.contains(event.target) && !popupMenu.contains(event.target)) {
                popupMenu.style.display = 'none';
            }
        }
    }
    showSection(period:any){
        this.selectedPeriod = period;
        this.cd.detectChanges(); 
        this.closeFilter();
    }

    closeFilter() {
        if(this.popupMenu?.nativeElement){
            const popupMenu = this.popupMenu.nativeElement;
            popupMenu.style.display = 'none';
        }
    }

    onSearch(event: any): void {
        this.searchText = event.target.value;
    }

    onHistorySearch(event: any): void {
        this.searchHistoryText = event?.target?.value?.trim();
    }
    scrollToBottom() {
        const chatHistory = document.querySelector('.chat-history');
        if (chatHistory) {
            chatHistory.scrollTop = chatHistory.scrollHeight;
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
